import { createFileRoute } from '@tanstack/react-router';
import { CountDetailPage } from '@/features/inventory/pages/count-pages';

export const Route = createFileRoute('/_app/inventory/count/$id')({ component: CountDetailPage });
